import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { flatFaqs, faqCategories } from "@/data/faqs";

export default function FAQAccordion({ limit, showCategories = false }) {
  const items = limit ? flatFaqs.slice(0, limit) : flatFaqs;

  if (showCategories) {
    return (
      <div className="space-y-12">
        {faqCategories.map((cat) => (
          <div key={cat.category}>
            <h3 className="text-2xl font-extrabold text-[#1F1E4E] mb-5">{cat.category}</h3>
            <Accordion type="single" collapsible className="space-y-3">
              {cat.items.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`${cat.category}-${i}`}
                  className="bg-white rounded-xl border border-slate-200 px-6 data-[state=open]:shadow-md"
                >
                  <AccordionTrigger data-testid={`faq-${cat.category}-${i}`} className="text-left font-bold text-[#1F1E4E] hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    );
  }

  return (
    <Accordion type="single" collapsible className="space-y-3">
      {items.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} className="bg-white rounded-xl border border-slate-200 px-6 data-[state=open]:shadow-md">
          <AccordionTrigger data-testid={`faq-item-${i}`} className="text-left font-bold text-[#1F1E4E] hover:no-underline">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
